// extracted by mini-css-extract-plugin
export default {"account-list":"AccountList_account-list__xcaya"};